module.exports = __webpack_public_path__ + "static/media/wheelchair.f2cd6be9.png";